<template>
  <div class="app-root">
    <header class="app-header">
      <h1 class="route-title">{{ currentRouteTitle }}</h1>
    </header>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppRoot',
  data() {
    return {
      routeTitles: {
        '/': 'AniSpark Welcome',
        '/anispark-debug': 'AI Avatar Demo',
        '/botim-preview': 'Botim Preview',
        '/botimai-blob-preview': 'BotimAI Blob Preview',
        '/3d-preview': '3D Avatar Preview',
      }
    }
  },
  computed: {
    currentRouteTitle() {
      return this.routeTitles[this.$route.path] || 'Welcome to AniSpark'
    }
  }
}
</script>

<style>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.route-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
}

.app-root {
  padding-top: 50px; /* Adjust for fixed header */
}

.app-container {
  height: calc(100vh - 50px) !important;
}

@media (max-width: 768px) {
  .app-root {
    padding-top: 0px;
  }
  .app-container {
    height: 100vh !important;
  }
}
</style> 